import { render, staticRenderFns } from "./TownHallReelOutbox.vue?vue&type=template&id=97c76ac4&scoped=true&"
import script from "./TownHallReelOutbox.vue?vue&type=script&lang=js&"
export * from "./TownHallReelOutbox.vue?vue&type=script&lang=js&"
import style0 from "./TownHallReelOutbox.vue?vue&type=style&index=0&id=97c76ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c76ac4",
  null
  
)

export default component.exports